<script>

    import { MEDIA_QUERIES } from '@/utils/constants';
    import { createNamespacedHelpers } from 'vuex';

    const _mqls = {};
    const _matches = {};
    const _queries = {};
    let _updater = null;

    const { mapActions } = createNamespacedHelpers('media');

    /**
     * An invisible ui component which sets up and monitors a bunch of media queries
     * updating the media state as needed
     */
    export default {

        name: 'mediaWatcher',

        methods: {

            ...mapActions(['update']),

            onQueryChange: function (mql) {
                const key = _queries[String(mql.media)];
                if ( key ) {
                    clearTimeout(_updater);
                    _matches[key] = mql.matches;
                    _updater = setTimeout(() => {
                        this.updateState(this.buildState());
                    }, 300);
                }
            },

            buildState: function () {
                let currents = {
                    current: ''
                };
                Object.keys(_matches).forEach((key) => {
                    if ( _matches[key] === true ) {
                        if ( key.indexOf('gt_') === -1 ) {
                            currents.current = key;
                        }
                    }
                });
                return {...{}, ..._matches, ...{zz: Date.now()}, ...currents};
            },

            updateState: function (newState) {
                this.update(newState);
            }
        },

        created: function () {
            for ( let key of Object.keys(MEDIA_QUERIES) ) {
                const qry = MEDIA_QUERIES[key];
                const mql = window.matchMedia(qry);
                _mqls[key] = mql;
                _queries[mql.media] = key;
                _matches[key] = false;
                mql.addListener(this.onQueryChange);
                this.onQueryChange(mql);
            }
        },

        beforeDestroy: function () {
            clearTimeout(_updater);
        }
    };

</script>

<template>
    <span class="ot-media-watcher"></span>
</template>

<style lang="less">

    @import (reference) '../../theme/minimum.less';

    .ot-media-watcher {
        width: 0;
        height: 0;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
    }
</style>
